<div class="contentHeight">
    <div class="droits">
        <div class="backgroundWhiteRound droitsContainer">
            <div class="form">
                <form [formGroup]="Form" class="formAssistance">
                    <mat-form-field class="country">
                        <mat-label>{{'scaleform.pays'|translate}}</mat-label>
                        <mat-select formControlName="Country">
                            <mat-option *ngFor="let country of countries" value="{{country.name}}"> {{country.txt|translate}} </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="nom">
                        <mat-label>{{'scaleform.nom'|translate}}</mat-label>
                        <input matInput formControlName="Nom" autocomplete="off">
                    </mat-form-field>

                    <mat-form-field class="prenom">
                        <mat-label>{{'scaleform.prenom'|translate}}</mat-label>
                        <input matInput formControlName="Prenom">
                    </mat-form-field>

                    <button class="search btn btn-secondary" (click)="searchUser()">{{ 'accountChoice.rechercher' | translate }}</button>
                    <button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isFormateur(role) || Utils.isMCI(role)" class="search btn btn-secondary" (click)="addUserDroits()">{{ 'manageaccount.addUser' | translate }}</button>
                </form>
            </div>

            <div class="userTab">
                <div>
                    <table mat-table [dataSource]="droitsSource" matSort (matSortChange)="sortUser($event,'1')" matSortActive="nom" matSortDirection="desc">
                        <ng-container matColumnDef="autoConnexion">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                            <td mat-cell *matCellDef="let res">
                                <div (click)="autoConnexion(res.idCtc)" class="pointer autoConnexion">
                                    <span><i aria-hidden="true" class="fal fa-sync fa-2x"></i></span>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="nom">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.nom'|translate}}</th>
                            <td mat-cell *matCellDef="let res">
                                <span>{{res.name}}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="prenom">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.prenom'|translate}}</th>
                            <td mat-cell *matCellDef="let res">
                                <span>{{res.firstname}}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="langue">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.langues'|translate}}</th>
                            <td mat-cell *matCellDef="let res">
                                <span>{{res.language}}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="Pays">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.pays'|translate}}</th>
                            <td mat-cell *matCellDef="let res">
                                <span>{{res.country}}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="region">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'manageaccount.region'|translate}}</th>
                            <td mat-cell *matCellDef="let res">
                                <span>{{res.dr}}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="lastConnection">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'manageaccount.lastConnection'|translate}}</th>
                            <td mat-cell *matCellDef="let res">
                                <span>{{(res.lastConnectionDate == null) ? '' : res.lastConnectionDate}}</span>
                            </td>
                        </ng-container>


                        <ng-container matColumnDef="droits">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'manageaccount.droits'|translate}}</th>
                            <td mat-cell *matCellDef="let res">
                                <span>{{res.droits}}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="delete">
                            <th mat-header-cell *matHeaderCellDef></th> <!-- Action -->
                            <td mat-cell *matCellDef="let res">
                                <div (click)="editDroits(res)" class="pointer editUser">
                                    <span><i aria-hidden="true" class="fal fa-edit fa-2x"></i></span>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="seeMore">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let res" class="">
                                <div class="seeMoreBtn" (click)="openSeeMoreModal(res)" matTooltip="{{'accountChoice.infosupp'|translate}}">
                                    <i aria-hidden="true" class="fal fa-chevron-right fa-2x primaryInfo actionIcon"></i>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Modal d'édition d'un utilisateur -->
<div class="modal" id="Modal" *ngIf="displayModal">
    <div class="modal-content">
        <div class="headerModal">
            <h3 class="leftFlex">{{'manageaccount.editUserRight'|translate}}</h3>
            <span *ngIf="!saveChangeDR" class="close pointer" (click)="closeModal()">  <i aria-hidden="true" class="fad fa-times fa-1x5 primaryRed"></i> </span>
        </div>

        <!-- Info utilisateurs -->
        <div class="userInfo" *ngIf="editUser">

            <div class="actionCustomer">
                <div class="buttonCustomer">
                    <button *ngIf="currentUser.bloquer == 1 && (Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isFormateur(role) || Utils.isMCI(role))" class="btnTall btn btn-secondary btn-success" (click)="confirmBloquerUser()">{{'manageaccount.DeblocageUser'|translate}}</button>
                    <button *ngIf="currentUser.bloquer == 0 && (Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isFormateur(role) || Utils.isMCI(role))" class="btnTall btn btn-secondary btn-danger" (click)="confirmBloquerUser()">{{'manageaccount.BlocageUser'|translate}}</button>
                    <button *ngIf="(Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isFormateur(role) || Utils.isMCI(role) || Utils.isCTC(role)) && (!currentUser.isAxalta && !currentUser.isAttum && !currentUser.isTechLine && !currentUser.isFournisseur)" class="btnTall btn btn-secondary btn-dark" (click)="getCustomers()">{{'manageaccount.showListUser'|translate}}</button>
                    <button *ngIf="(Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isFormateur(role) || Utils.isMCI(role) || Utils.isCTC(role)) && (!currentUser.isAxalta && !currentUser.isAttum && !currentUser.isTechLine && !currentUser.isFournisseur)" class="btnTall btn btn-secondary btn-dark" (click)="getCustomersDR()">{{'manageaccount.showAllListUser'|translate}}</button>
                    <button *ngIf="customersList.length == 0 && (Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isFormateur(role) || Utils.isMCI(role)) && (!currentUser.isAxalta && !currentUser.isAttum && !currentUser.isTechLine && !currentUser.isFournisseur)" class="btnTall btn btn-danger" (click)="confirmDeleteUser()"> {{'manageaccount.deleteUser'|translate}} &nbsp;<i aria-hidden="true" class="fas fa-trash-alt"></i></button>
                </div>
                <span class="msgErreur" *ngIf="erreur">{{'manageaccount.noUserAssociate'|translate}}</span>
            </div>

            <div class="content">
                <div class="info">

                    <form [formGroup]="FormDR" class="formAssistance">
                        <strong>{{'assistance.info'|translate}}:</strong><br />

                        <mat-form-field class="col-6">
                            <mat-label>{{'scaleform.mail'|translate}}</mat-label>
                            <input matInput formControlName="mail" required />
                        </mat-form-field>

                        <mat-form-field class="col-6">
                            <mat-label>{{'scaleform.nom'|translate}}</mat-label>
                            <input matInput formControlName="name" required />
                        </mat-form-field>

                        <mat-form-field class="col-6">
                            <mat-label>{{'scaleform.prenom'|translate}}</mat-label>
                            <input matInput formControlName="firstname" required />
                        </mat-form-field>

                        <mat-form-field class="col-6">
                            <mat-label>{{'assistance.phone'|translate}}</mat-label>
                            <input matInput formControlName="phone" required />
                        </mat-form-field>

                        <mat-form-field class="col-6">
                            <mat-label>{{'scaleform.langues'|translate}}</mat-label>
                            <mat-select formControlName="language" required>
                                <mat-option *ngFor="let language of languages" value="{{language.name}}"> {{language.txt|translate}} </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="col-6">
                            <mat-label>{{'scaleform.pays'|translate}}</mat-label>
                            <mat-select formControlName="country" required (selectionChange)="getRegions('update')">
                                <mat-option *ngFor="let country of countries" value="{{country.name}}"> {{country.txt|translate}} </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <div class="DRField col-6" *ngIf="currentUser.country && (currentUser.country.toLowerCase() == 'france' || currentUser.country.toLowerCase() == 'spain' || currentUser.country.toLowerCase() == 'united kingdom' || countryTemp.toLowerCase() == 'france' || countryTemp.toLowerCase() == 'spain' || countryTemp.toLowerCase() == 'united kingdom') && !currentUser.isInternCorporate && !currentUser.isClientCorporate && !currentUser.isTechLine && !currentUser.isFournisseur && !currentUser.isAxalta && !currentUser.isAttum && enableDR">
                            <mat-form-field class="newDR">
                                <mat-label>{{'manageaccount.DRlite'|translate}}</mat-label>
                                <mat-select formControlName="newDR" required (selectionChange)="changeDR('update')">
                                    <mat-option *ngFor="let region of regions" value="{{region}}"> {{region}} </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <mat-form-field *ngIf="Utils.isAdminLacour(role)" class="col-6">
                            <mat-label>Unisite</mat-label>
                            <input matInput formControlName="unisiteCode" />
                        </mat-form-field>
                        <div *ngIf="Utils.isAdminLacour(role)" class="col-6">
                            <mat-checkbox placeholder="Utilisateur Lacour" formControlName="userLacour" [checked]="currentUser.userLacour" (change)="changeUserLacour('update')">Utilisateur Lacour</mat-checkbox>
                        </div>
                    </form>

                </div>
                <div class="check" *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isFormateur(role) || Utils.isMCI(role)">
                    <strong>{{'manageaccount.droits'|translate}}:</strong>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role)" [checked]="currentUser.droits.indexOf('271')>=0" (change)="changeAdminRenault('update')">Admin Corpo</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role)" [checked]="currentUser.droits.indexOf('903')>=0" (change)="changeAdminRenaultPays('update')">Admin Pays</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" [checked]="currentUser.droits.indexOf('258')>=0" (change)="changeRT('update')">Référent Technique</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role)" [checked]="currentUser.droits.indexOf('272')>=0 || currentUser.droits.indexOf('283')>=0" (change)="changeMCI('update')">MCI / Manager Ixell / Formateur</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isFormateur(role) || Utils.isMCI(role)" [checked]="currentUser.droits.indexOf('255')>=0" (change)="changeCTC('update')">CTC</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isFormateur(role) || Utils.isMCI(role)" [checked]="currentUser.droits.indexOf('900')>=0" (change)="changeInternCorporate('update')">ABC, ABI, CTR</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" [checked]="currentUser.droits.indexOf('901')>=0" (change)="changeClientCorporate('update')">Corporate / Renault</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" [checked]="currentUser.droits.indexOf('268')>=0" (change)="changeAxalta('update')">Axalta</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" [checked]="currentUser.droits.indexOf('269')>=0" (change)="changeAttum('update')">Attum</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" [checked]="currentUser.droits.indexOf('265')>=0" (change)="changeTechLine('update')">TechLine</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" [checked]="currentUser.droits.indexOf('904')>=0" (change)="changeFournisseur('update')">Fournisseur</mat-radio-button>
                </div>

                <div class="check" *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role)">
                    <!--<mat-checkbox *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" [disabled]="(!Utils.isAdminLacour(role) && !Utils.isAdminRenault(role) && !Utils.isAdminRenaultPays(role)) || currentUser.isAxalta || currentUser.isAttum || droitTemp.indexOf(268)>=0 || droitTemp.indexOf(269)>=0" [checked]="currentUser.droits.indexOf('enAttente')>=0" (change)="changeRT()">Documents</mat-checkbox>-->
                    <!--<mat-checkbox *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" [disabled]="(!Utils.isAdminLacour(role) && !Utils.isAdminRenault(role) && !Utils.isAdminRenaultPays(role)) || currentUser.isAxalta || currentUser.isAttum || droitTemp.indexOf(268)>=0 || droitTemp.indexOf(269)>=0" [checked]="currentUser.droits.indexOf('281')>=0" (change)="changeDocuments()">Documents</mat-checkbox>-->
                    <mat-checkbox *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" [disabled]="(!Utils.isAdminLacour(role) && !Utils.isAdminRenault(role) && !Utils.isAdminRenaultPays(role)) || currentUser.isAxalta || currentUser.isAttum || currentUser.isInternCorporate || currentUser.isClientCorporate || currentUser.isTechLine || currentUser.isFournisseur || droitTemp.indexOf(268)>=0 || droitTemp.indexOf(269)>=0" [checked]="currentUser.droits.indexOf('281')>=0" (change)="changeMonitoring()">Monitoring</mat-checkbox>
                    <mat-checkbox *ngIf="Utils.isAdminLacour(role)" [checked]="currentUser.droits.indexOf('278')>=0" (change)="changePreprod()">Preprod</mat-checkbox>
                    <mat-checkbox *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" [checked]="currentUser.droits.indexOf('902')>=0" (change)="changeAccessGPI()">IxellVision Connect</mat-checkbox>
                </div>

            </div>
            <div class="buttons">
                <button *ngIf="(Utils.isAdminLacour(role) || Utils.isRT(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isFormateur(role) || Utils.isMCI(role))" class="search btn btn-secondary" (click)="saveCustomer('update')">{{'manageaccount.save'|translate}}</button>
                <button *ngIf="(Utils.isAdminLacour(role) || Utils.isRT(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isFormateur(role) || Utils.isMCI(role))" class="search btn btn-secondary" (click)="saveCustomerAndSend('update')">{{'manageaccount.sendID'|translate}}</button>
                <button *ngIf="(Utils.isAdminLacour(role) || Utils.isRT(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isFormateur(role) || Utils.isMCI(role))" class="search btn btn-secondary" (click)="closeModal()">{{'planning.cancel'|translate}}</button>
                <button *ngIf="(!Utils.isAdminLacour(role) && !Utils.isRT(role) && !Utils.isAdminRenault(role) && !Utils.isAdminRenaultPays(role) && !Utils.isFormateur(role) && !Utils.isMCI(role))" class="search btn btn-secondary" (click)="closeModal()">{{'scaleform.retour'|translate}}</button>
            </div>
        </div>

        <!-- Customer list -->
        <div class="customerList" *ngIf="showCustomer && !allocate">
            <div class="btnRetour">
                <button (click)="back()" class="btn btn-secondary">{{'scaleform.retour'|translate}}</button>
            </div>
            <div class="btnAllocate">
                <button *ngIf="(Utils.isAdminLacour(role) || Utils.isRT(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isFormateur(role) || Utils.isMCI(role))" (click)="allocateCustomers()" class="btn btn-secondary btnTall">{{'manageaccount.associateUser'|translate}}</button>
            </div>

            <div class="msg">
                <span class="error" *ngIf="saveChangeDR">{{'manageaccount.selectAssociateUser'|translate}}</span>
            </div>

            <div class="msg">
                <span class="error" *ngIf="this.selection.selected.length == 0 && (Utils.isAdminLacour(role) ||  Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isFormateur(role) || Utils.isMCI(role))">{{'manageaccount.selectMinOneUser'|translate}}</span>
            </div>
            <table mat-table class="table lstclients bg-white table-hover customers" matSort [dataSource]="customersSource" (matSortChange)="sortCustomer($event,'1')">
                <ng-container matColumnDef="companySocialReason">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.raisonsociale'|translate}}</th>
                    <td mat-cell *matCellDef="let res" class="socialReason">{{res.socialReason}}</td>
                </ng-container>

                <ng-container matColumnDef="address">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.adresse'|translate}}</th>
                    <td mat-cell *matCellDef="let res" class="address">
                        <div class="address">
                            <span>{{res.address}}</span>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="city">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.ville'|translate}}</th>
                    <td mat-cell *matCellDef="let res" class="address">
                        <div class="city">
                            <span>{{res.postalCode}} </span> <span>{{res.city}}</span>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.prenom'|translate}}</th>
                    <td mat-cell *matCellDef="let res" class="firstName">{{res.firstname}}</td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.nom'|translate}}</th>
                    <td mat-cell *matCellDef="let res" class="name">{{res.name}}</td>
                </ng-container>

                <ng-container matColumnDef="check">
                    <th mat-header-cell *matHeaderCellDef class="selection">
                        <!-- mat-sort-header -->
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                                      [checked]="selection.hasValue() && isAllSelected()"
                                      [indeterminate]="selection.hasValue() && !isAllSelected()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row" class="selection">
                        <mat-checkbox (click)="$event.stopPropagation()"
                                      (change)="$event ? selection.toggle(row) : null"
                                      [checked]="selection.isSelected(row)">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsCustomer; sticky:true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsCustomer"></tr>
            </table>
        </div>

        <!-- allocation customer à ctc et region -->
        <div *ngIf="allocate">
            <div class="btnRetour">
                <button (click)="backShowCustomer()" class="btn btn-secondary">{{'scaleform.retour'|translate}}</button>
            </div>
            <span>{{'manageaccount.associateNumberUser'|translate}} {{selection.length}} {{'manageaccount.clients'|translate}}</span><br /><!-- Affectation de {selection.length}} client(s) -->
            <form [formGroup]="FormCustomer" class="formAssistance">
                <mat-form-field class="newDR">
                    <mat-label>Régions</mat-label>
                    <mat-select formControlName="newDR" required (selectionChange)="getCtc()">
                        <mat-option *ngFor="let region of regions" value="{{region}}"> {{region}} </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="newCTC">
                    <mat-label>CTC</mat-label>
                    <mat-select formControlName="newCTC" required>
                        <mat-option *ngFor="let ctc of ctcLst" value="{{ctc.idCtc}}"> {{ctc.name}}&nbsp;{{ctc.firstname}} </mat-option>
                    </mat-select>
                </mat-form-field>
            </form>
            <button (click)="saveAllocation()" class="btn btn-secondary">{{'shoppingcart.validate'|translate}}</button>
        </div>






        <!-- Customer list DR -->
        <div class="customerList" *ngIf="showCustomerDR && !allocateDR">
            <div class="btnRetour">
                <button (click)="back()" class="btn btn-secondary">{{'scaleform.retour'|translate}}</button>
            </div>
            <div class="btnAllocate">
                <button *ngIf="(Utils.isAdminLacour(role) || Utils.isRT(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isFormateur(role) || Utils.isMCI(role))" (click)="allocateCustomersDR()" class="btn btn-secondary btnTall">{{'manageaccount.associateUser'|translate}}</button>
            </div>

            <div class="msg">
                <span class="error" *ngIf="this.selectionDR.selected.length == 0 && (Utils.isAdminLacour(role) ||  Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isFormateur(role) || Utils.isMCI(role))">{{'manageaccount.selectMinOneUser'|translate}}</span>
            </div>
            <table mat-table class="table lstclients bg-white table-hover customers" matSort (matSortChange)="sortUserCustomersDR($event,'1')" [dataSource]="customersDRSource">
                <ng-container matColumnDef="companySocialReason">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.raisonsociale'|translate}}</th>
                    <td mat-cell *matCellDef="let res" class="socialReason">{{res.socialReason}}</td>
                </ng-container>

                <ng-container matColumnDef="address">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.adresse'|translate}}</th>
                    <td mat-cell *matCellDef="let res" class="address">
                        <div class="address">
                            <span>{{res.address}}</span>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="city">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.ville'|translate}}</th>
                    <td mat-cell *matCellDef="let res" class="address">
                        <div class="city">
                            <span>{{res.postalCode}} </span> <span>{{res.city}}</span>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.prenom'|translate}}</th>
                    <td mat-cell *matCellDef="let res" class="firstName">{{res.firstname}}</td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.nom'|translate}}</th>
                    <td mat-cell *matCellDef="let res" class="name">{{res.name}}</td>
                </ng-container>

                <ng-container matColumnDef="ctcName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'manageaccount.ctcName'|translate}}</th>
                    <td mat-cell *matCellDef="let res" class="ctcName">{{res.ctcName}}</td>
                </ng-container>

                <ng-container matColumnDef="check">
                    <th mat-header-cell *matHeaderCellDef class="selection">
                        <!-- mat-sort-header -->
                        <mat-checkbox (change)="$event ? masterToggleDR() : null"
                                      [checked]="selectionDR.hasValue() && isAllSelectedDR()"
                                      [indeterminate]="selectionDR.hasValue() && !isAllSelectedDR()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row" class="selection">
                        <mat-checkbox (click)="$event.stopPropagation()"
                                      (change)="$event ? selectionDR.toggle(row) : null"
                                      [checked]="selectionDR.isSelected(row)">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsCustomerDR; sticky:true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsCustomerDR"></tr>
            </table>
        </div>

        <!-- allocation customer à ctc et region -->
        <div *ngIf="allocateDR">
            <div class="btnRetour">
                <button (click)="backShowCustomerDR()" class="btn btn-secondary">{{'scaleform.retour'|translate}}</button>
            </div>
            <span>{{'manageaccount.associateNumberUser'|translate}} {{selection.length}} {{'manageaccount.clients'|translate}}</span><br /><!-- Affectation de {selection.length}} client(s) -->
            <form [formGroup]="FormCustomer" class="formAssistance">
                <mat-form-field class="newDR">
                    <mat-label>Régions</mat-label>
                    <mat-select formControlName="newDR" required (selectionChange)="getCtc()">
                        <mat-option *ngFor="let region of regions" value="{{region}}"> {{region}} </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="newCTC">
                    <mat-label>CTC</mat-label>
                    <mat-select formControlName="newCTC" required>
                        <mat-option *ngFor="let ctc of ctcLst" value="{{ctc.idCtc}}"> {{ctc.name}}&nbsp;{{ctc.firstname}} </mat-option>
                    </mat-select>
                </mat-form-field>
            </form>
            <button (click)="saveAllAllocationDR()" class="btn btn-secondary">{{'shoppingcart.validate'|translate}}</button>
        </div>





        <!-- suppression de l'utilisateur -->
        <div *ngIf="delete" class="validationDelete">
            <h5>{{'manageaccount.confirmDeleteUser'|translate}} {{currentUser.firstname}} {{currentUser.name}} ?</h5><br /><!-- Confirmez-vous la suppression de l'utilisateur : {currentUser.firstname}} {currentUser.name}} ? -->
            <div class="btnValidation">
                <button class="btn btn-success" (click)="deleteUser()">{{'assistance.oui'|translate}}</button>
                <button class="btn btn-danger" (click)="cancelDeleteUser()">{{'assistance.non'|translate}}</button>
            </div>
        </div>

        <!-- Blocage de l'utilisateur -->
        <div *ngIf="blocage" class="validationBlocage">
            <h5 *ngIf="currentUser.bloquer == 1">{{'manageaccount.confirmDeblocageUser'|translate}} {{currentUser.firstname}} {{currentUser.name}} ?</h5><br /><!-- Confirmez-vous la suppression de l'utilisateur : {currentUser.firstname}} {currentUser.name}} ? -->
            <h5 *ngIf="currentUser.bloquer == 0">{{'manageaccount.confirmBlocageUser'|translate}} {{currentUser.firstname}} {{currentUser.name}} ?</h5><br /><!-- Confirmez-vous la suppression de l'utilisateur : {currentUser.firstname}} {currentUser.name}} ? -->
            <div class="btnValidation">
                <button class="btn btn-success" (click)="BloquerUser()">{{'assistance.oui'|translate}}</button>
                <button class="btn btn-danger" (click)="cancelBloquerUser()">{{'assistance.non'|translate}}</button>
            </div>
        </div>

        <!-- changement de region de l'utilisateur ayant des clients associé' -->
        <div *ngIf="saveChangeDR && inProgressChangeDR">
            <h5>{{'manageaccount.msgAssociateUserDR'|translate}}</h5><br />
            <h5>{{'manageaccount.msgAssociateUserDR2'|translate}}</h5><br />
            <div class="btnValidation">
                <button class="btn btn-success" (click)="saveAllocationDR()">{{'assistance.oui'|translate}}</button>
                <button class="btn btn-danger" (click)="getCustomersDR()">{{'assistance.non'|translate}}</button>
            </div>
        </div>

    </div>
</div>



<!-- Modal d'ajout d'un utilisateur -->
<div class="modal" id="Modal" *ngIf="displayModalAdd">
    <div class="modal-content">
        <div class="headerModal">
            <h3 class="leftFlex">{{'manageaccount.addUser'|translate}}</h3>
            <span *ngIf="!saveChangeDR" class="close pointer" (click)="closeModal()">  <i aria-hidden="true" class="fad fa-times fa-1x5 primaryRed"></i> </span>
        </div>

        <!-- Info utilisateurs -->
        <div class="userInfo" *ngIf="addUser">

            <div class="content">
                <div class="info">

                    <form [formGroup]="FormDRAdd" class="formAssistance">
                        <strong>{{'assistance.info'|translate}}:</strong><br />

                        <mat-form-field class="col-6">
                            <mat-label>{{'scaleform.mail'|translate}}</mat-label>
                            <input matInput formControlName="mail" required />
                        </mat-form-field>

                        <mat-form-field class="col-6">
                            <mat-label>{{'scaleform.nom'|translate}}</mat-label>
                            <input matInput formControlName="name" required />
                        </mat-form-field>

                        <mat-form-field class="col-6">
                            <mat-label>{{'scaleform.prenom'|translate}}</mat-label>
                            <input matInput formControlName="firstname" required />
                        </mat-form-field>

                        <mat-form-field class="col-6">
                            <mat-label>{{'assistance.phone'|translate}}</mat-label>
                            <input matInput formControlName="phone" required />
                        </mat-form-field>

                        <mat-form-field class="col-6">
                            <mat-label>{{'scaleform.langues'|translate}}</mat-label>
                            <mat-select formControlName="language" required>
                                <mat-option *ngFor="let language of languages" value="{{language.name}}"> {{language.txt|translate}} </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="col-6">
                            <mat-label>{{'scaleform.pays'|translate}}</mat-label>
                            <mat-select formControlName="country" required (selectionChange)="getRegions('new')">
                                <mat-option *ngFor="let country of countries" value="{{country.name}}"> {{country.txt|translate}} </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <div class="DRField col-6" *ngIf="enableDR">
                            <mat-form-field class="newDR">
                                <mat-label>{{'manageaccount.DRlite'|translate}}</mat-label>
                                <mat-select formControlName="newDR" required (selectionChange)="changeDR('new')">
                                    <mat-option *ngFor="let region of regions" value="{{region}}"> {{region}} </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <mat-form-field *ngIf="Utils.isAdminLacour(role)" class="col-6">
                            <mat-label>Unisite</mat-label>
                            <input matInput formControlName="unisiteCode" />
                        </mat-form-field>
                        <div *ngIf="Utils.isAdminLacour(role)" class="col-6">
                            <mat-checkbox placeholder="Utilisateur Lacour" formControlName="userLacour" (change)="changeUserLacour('new')">Utilisateur Lacour</mat-checkbox>
                        </div>

                    </form>

                </div>
                <div class="check" *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isMCI(role) || Utils.isCTC(role)">
                    <strong>{{'manageaccount.droits'|translate}}:</strong>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role)" (change)="changeAdminRenault('new')">Admin Corpo</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role)" (change)="changeAdminRenaultPays('new')">Admin Pays</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" (change)="changeRT('new')">Référent Technique</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role)" (change)="changeMCI('new')">MCI / Manager Ixell / Formateur</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isFormateur(role) || Utils.isMCI(role)" (change)="changeCTC('new')">CTC</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isFormateur(role) || Utils.isMCI(role)" (change)="changeInternCorporate('new')">ABC, ABI, CTR</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" (change)="changeClientCorporate('new')">Corporate / Renault</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" (change)="changeAxalta('new')">Axalta</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" (change)="changeAttum('new')">Attum</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" (change)="changeTechLine('new')">TechLine</mat-radio-button>
                    <mat-radio-button *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" (change)="changeFournisseur('new')">Fournisseur</mat-radio-button>
                </div>

                <div class="check" *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)">
                    <!--<mat-checkbox *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role)" [disabled]="(!Utils.isAdminLacour(role) && !Utils.isAdminRenault(role)) || Utils.isAdminRenaultPays(role) || currentUser.isAxalta || currentUser.isAttum || droitTemp.indexOf(268)>=0 || droitTemp.indexOf(269)>=0" (change)="changeDocuments()">Documents</mat-checkbox>-->
                    <mat-checkbox *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" [disabled]="(!Utils.isAdminLacour(role) && !Utils.isAdminRenault(role) && !Utils.isAdminRenaultPays(role)) || currentUser.isAxalta || currentUser.isAttum || currentUser.isInternCorporate || currentUser.isClientCorporate || currentUser.isTechLine || currentUser.isFournisseur || droitTemp.indexOf(268)>=0 || droitTemp.indexOf(269)>=0" (change)="changeMonitoring()">Monitoring</mat-checkbox>
                    <mat-checkbox *ngIf="Utils.isAdminLacour(role)" (change)="changePreprod()">Preprod</mat-checkbox>
                    <mat-checkbox *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role)" (change)="changeAccessGPI()">IxellVision Connect</mat-checkbox>
                </div>

            </div>
            <div class="buttons">
                <button *ngIf="(Utils.isAdminLacour(role) || Utils.isRT(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isFormateur(role) || Utils.isRT(role) || Utils.isMCI(role) || Utils.isCTC(role))" class="search btn btn-secondary" (click)="saveCustomerAndSend('new')">{{'manageaccount.sendID'|translate}}</button>
                <button *ngIf="(Utils.isAdminLacour(role) || Utils.isRT(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isFormateur(role) || Utils.isMCI(role))" class="search btn btn-secondary" (click)="closeModal()">{{'planning.cancel'|translate}}</button>
            </div>
        </div>

    </div>
</div>


<!-- Modal d'erreur -->
<div class="modal" id="Modal" *ngIf="displayModalError">
    <div class="modal-content modal-content-error">
        <div class="headerModal">
            <h3 class="leftFlex">{{'planning.errorTitle'|translate}}</h3>
            <span class="close pointer" (click)="closeModalError()">  <i aria-hidden="true" class="fad fa-times fa-1x5 primaryRed"></i> </span>
        </div>

        <!-- message erreur 1 -->
        <div class="modalErrorText" *ngIf="messageError1">
            {{'manageaccount.erreur1'|translate}}
        </div>

        <!-- message erreur 2 -->
        <div class="modalErrorText" *ngIf="messageError2">
            {{'manageaccount.erreur2'|translate}}

        </div>

        <!-- message erreur 3 -->
        <div class="modalErrorText" *ngIf="messageError3">
            {{'manageaccount.erreur3'|translate}}

        </div>

        <!-- message erreur 4 -->
        <div class="modalErrorText" *ngIf="messageError4">
            {{'manageaccount.erreur4'|translate}}

        </div>

        <div class="buttons">
            <button class="search btn btn-secondary" (click)="closeModalError()">{{'shoppingcart.validate'|translate}}</button>
        </div>
    </div>
</div>


<!-- Modal d'affichage de détails -->
<div class="modal" id="Modal" *ngIf="displayModalSeeMore">
    <div class="modal-content">
        <table>
            <tbody>
                <tr *ngIf="displayedColumns.includes('nom')">
                    <th>{{'scaleform.nom'|translate}}</th>
                    <td>{{seeMoreCustomer.name}}</td>
                </tr>
                <tr *ngIf="displayedColumns.includes('prenom')">
                    <th>{{'scaleform.prenom'|translate}}</th>
                    <td>{{seeMoreCustomer.firstname}}</td>
                </tr>
                <tr *ngIf="displayedColumns.includes('langue')">
                    <th>{{'scaleform.langues'|translate}}</th>
                    <td>{{seeMoreCustomer.language}}</td>
                </tr>
                <tr *ngIf="displayedColumns.includes('Pays')">
                    <th>{{'scaleform.pays'|translate}}</th>
                    <td>{{seeMoreCustomer.country}}</td>
                </tr>
                <tr *ngIf="displayedColumns.includes('region')">
                    <th>{{'manageaccount.region'|translate}}</th>
                    <td>{{seeMoreCustomer.dr}}</td>
                </tr>
                <tr *ngIf="displayedColumns.includes('lastConnection')">
                    <th>{{'manageaccount.lastConnection'|translate}}</th>
                    <td>{{(seeMoreCustomer.lastConnectionDate == null) ? '' : seeMoreCustomer.lastConnectionDate}}</td>
                </tr>
                <tr *ngIf="displayedColumns.includes('droits')">
                    <th>{{'manageaccount.droits'|translate}}</th>
                    <td>{{seeMoreCustomer.droits}}</td>
                </tr>
                <tr *ngIf="displayedColumns.includes('delete')">
                    <th></th>
                    <td>
                        <div (click)="closeModal(); editDroits(seeMoreCustomer)" class="pointer editUser">
                            <span><i aria-hidden="true" class="fal fa-edit fa-2x"></i></span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="btnConfirm">
            <button class="btn btn-danger" (click)="closeModal()">{{'activlist.fermer'|translate}} </button>
        </div>
    </div>
</div>


<!-- Modal preprod -->
<div id="infoPreprodModal" class="modal" *ngIf="infoPreprod">
    <div class="modal-content" id="infoPreprodContent">

        <div class="col-12 text-center">
            <span class="text-right pointer close" (click)="closeModalPreprod('infoPreprodModal');">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed "></i>
            </span>
            <h1 class="modal-title"> Informations preprod </h1>
        </div>

        <div class="col-12">
            <h3 class="modal-title text-center"> Attention, vous êtes sur un environnement de test. Aucun mail n'est envoyer pour initialiser / modifier le mot de passe du client.</h3>
        </div>
        <div class="btnConfirm row">
            <button class="btn btn-danger col-2 col-lg-2 col-md-2 col-sm-2 " (click)="closeModalPreprod('infoPreprodModal')">{{'activlist.fermer'|translate|titlecase}} </button>
        </div>
    </div>
</div>
